import { AxiosResponse } from "axios";
import * as stream from "stream";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectCurrentUser,IpaUserExtended} from "../../../shared/sagas/auth/authSlice";
import { getCancelOTP, getCancelStatus, getApproveRefund, getExportTransDetails, setExportTransDetails, setExportTransDetailsError, getChargebackDetails, setChargebackDetails, setChargebackDetailsError, getChangeChargebackStatus, setChangeChargebackStatus, setErrorChangeChargebackStatus, setTransactionHistoryDetailsExport } from "./pmTransactionsSlice";
import { CancelStatusObject, Configuration, PmsApi, TransactionsSearchResponseDto, RefundActionResponseDto, TransactionItemDetailsV2Dto, TransactionSearchParamsDTO, ValidRequestMessages, CancelRefundDto, PaymentRequestDto, ChargebackDetailsResponseDto, PaymentActionDto, PaymentsApi } from "@inosio/payments-sdk";
import {
  getDenyRefund,
  getRefundTrxDetails,
  getTransactionHistoryDetails,
  setApproveRefundError,
  setApproveRefundResponse,
  setCancelOTPError,
  setCancelStatusError,
  getPaymentRequestByTransUuid,
  setPaymentRequestByTransUuid,
  setPaymentRequestByTransUuidError,
} from "./pmTransactionsSlice";
import { setCancelStatusResponse, setDenyRefundError, setDenyRefundResponse, setRefundTrxDetailsError, setRefundTrxDetailsResponse, setTransactionHistoryDetails } from "./pmTransactionsSlice";
import { setCancelOTPResponse, setAdhocRefundResponse, setAdhocRefundError, getAdhocRefund, setCancelRefundError, getCancelRefund, setCancelRefundResponse, setTransactionHistoryDetailError } from "./pmTransactionsSlice";
import { Stream } from "stream";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

enum reportExportType {
  PDF = "PDF",
  CSV = "CSV",
}

export function requestGetTransactionHistory(access_token: string, pmUUID: string, trxdto: TransactionSearchParamsDTO, exportAs?: reportExportType, fileName?: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);
  const responseType = exportAs === undefined ? "json" : "blob";
  const contentDisposition = exportAs === undefined ? "" : exportAs === "CSV" ? "text/csv" : "application/pdf";
  const headerParams = {
    "Content-Disposition": contentDisposition,
  };

  return ipaPmAPI.searchTransactionsByPM(pmUUID, trxdto, exportAs, fileName, { responseType, headers: headerParams });
}

export function requestGetCancelStatus(access_token: string, pmUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.getCancelEligibilityStatus(pmUuid, transactionUuid);
}

export function requestCancelOTP(access_token: string, pmUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.cancelPayment(pmUuid, transactionUuid, { status: ValidRequestMessages.Cancel });
}

export function requestApproveRefund(access_token: string, pmUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.takeRefundAction(pmUuid, transactionUuid, { status: ValidRequestMessages.Approved });
}

export function requestDenyRefund(access_token: string, pmUuid: string, transactionUuid: string, message: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.takeRefundAction(pmUuid, transactionUuid, { status: ValidRequestMessages.Denied, requestMessage: message });
}

export function requestGetRefundTrxDetails(access_token: string, pmUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.getTransactionDetails(pmUuid, transactionUuid);
}

export function requestAdhocRefund(access_token: string, pmUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.takeRefundAction(pmUuid, transactionUuid, { status: ValidRequestMessages.Adhoc });
}

export function requestCancelRefund(access_token: string, pmUuid: string, transactionUuid: string, cancelRefundDto: CancelRefundDto) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.cancelRefund(pmUuid, transactionUuid, cancelRefundDto);
}

export function requestPaymentRequestByTransUuid(access_token: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPaymentReqDetailsByTransUuid(transactionUuid);
}

export function requestExportTransDetail(transactionUuid: string) {
  const responseType = "arraybuffer";
  const contentDisposition = "application/pdf";
  const headerParams = {
    "Content-Disposition": contentDisposition,
  };

  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.exportTransactionDetails(transactionUuid, { responseType, headers: headerParams });
}

export function requestChargebackDetails(access_token: string, pmUUID: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const pmtAPI = new PmsApi(apiConfig);
  return pmtAPI.getChargebackDetails(pmUUID, transactionUuid);
}

export function requestChangeChargebackStatus(access_token: string, pmUUID: string, transactionUuid: string, paymentAction: PaymentActionDto ) {
  apiConfig.accessToken = access_token;
  const pmtAPI = new PmsApi(apiConfig);
  return pmtAPI.takeChargebackAction(pmUUID,transactionUuid, paymentAction);
}

export function* handleGetTransactionHistory(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    let response: AxiosResponse<TransactionsSearchResponseDto | stream> = yield call(requestGetTransactionHistory, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload, action.payload.exportAs, action.payload.fileName);

    if (response.headers["content-type"].startsWith("application/json")) {
      const { data } = response;
      yield put(setTransactionHistoryDetails(data));
    } else {
      const fileType = action.payload.exportAs === "PDF" ? "application/pdf" : "text/csv";
      const fileExtension = action.payload.exportAs === "PDF" ? "pdf" : "csv";

      const url = window.URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: fileType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${action.payload.fileName}.${fileExtension}`); //or any other extension
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      yield put(setTransactionHistoryDetailsExport());
    }
  } catch (error: any) {
    yield put(
      setTransactionHistoryDetailError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* handleGetCancelStatus(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<CancelStatusObject> = yield call(requestGetCancelStatus, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);

    const { data } = response;
    yield put(setCancelStatusResponse(data));
  } catch (error: any) {
    yield put(setCancelStatusError({ message: error?.response?.data?.message }));
  }
}
export function* handleCancelOTP(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestCancelOTP, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);

    const { data } = response;
    yield put(setCancelOTPResponse(data));
  } catch (error: any) {
    yield put(setCancelOTPError({ message: error?.response?.data?.message }));
  }
}
export function* handleApproveRefund(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<RefundActionResponseDto> = yield call(requestApproveRefund, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);

    const { data } = response;
    yield put(setApproveRefundResponse(data));
  } catch (error: any) {
    yield put(setApproveRefundError({ message: error?.response?.data?.message }));
  }
}
export function* handleDenyRefund(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<RefundActionResponseDto> = yield call(requestDenyRefund, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid, action.payload.message);

    const { data } = response;
    yield put(setDenyRefundResponse(data));
  } catch (error: any) {
    yield put(setDenyRefundError({ message: error?.response?.data?.message }));
  }
}

export function* handleAdhocRefund(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<RefundActionResponseDto> = yield call(requestAdhocRefund, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);

    const { data } = response;
    yield put(setAdhocRefundResponse(data));
  } catch (error: any) {
    yield put(setAdhocRefundError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetRefundTrxDetails(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<TransactionItemDetailsV2Dto> = yield call(requestGetRefundTrxDetails, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);

    const { data } = response;
    yield put(setRefundTrxDetailsResponse(data));
  } catch (error: any) {
    yield put(setRefundTrxDetailsError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetCancelRefund(action: { type: typeof getCancelRefund; payload: CancelRefundDto; transactionUUid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestCancelRefund, currentUser.accessToken, currentUser.currentProfile.uuid, action.transactionUUid, action.payload);

    yield put(setCancelRefundResponse({}));
  } catch (error: any) {
    yield put(setCancelRefundError({ message: error?.response?.data?.message }));
  }
}

export function* handlePaymentReqByTransUuid(action: { type: typeof getPaymentRequestByTransUuid; payload: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<PaymentRequestDto> = yield call(requestPaymentRequestByTransUuid, currentUser.accessToken,  action.payload);
    const { data } = response;
    yield put(setPaymentRequestByTransUuid(data));
  } catch (error: any) {
    yield put(setPaymentRequestByTransUuidError({ message: error?.response?.data?.message }));
  }
}

export function* handleExportTransDetails(action: { type: typeof getExportTransDetails; payload: string }) {
  try {
    const response: AxiosResponse<Stream> = yield call(requestExportTransDetail, action.payload);

    // download stream
    let fileName = "transaction_details.pdf"; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers["content-disposition"]);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, "");
    }

    const url = window.URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportTransDetails());
  } catch (error: any) {
    yield put(setExportTransDetailsError({ message: error?.response?.data?.message }));
  }
}

export function* handleGetChargebackDetails(action: { type: typeof getChargebackDetails; payload: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ChargebackDetailsResponseDto> = yield call(requestChargebackDetails, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;

    yield put(setChargebackDetails(data));
  } catch (error: any) {
    yield put(setChargebackDetailsError({ message: error?.response?.data?.message }));
  }
}

export function* handleChangeChargebackStatus(action: { type: typeof getChangeChargebackStatus, payload: PaymentActionDto, transactionUUID:string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestChangeChargebackStatus, currentUser.accessToken, currentUser.currentProfile.uuid, action.transactionUUID, action.payload);
    yield put(setChangeChargebackStatus());
  } catch (error: any) {
    yield put(setErrorChangeChargebackStatus({ message: error?.response?.data?.message }));
  }
}

export function* pmPaymentsSaga() {
  yield takeLatest(getTransactionHistoryDetails.type, handleGetTransactionHistory);
  yield takeLatest(getCancelStatus.type, handleGetCancelStatus);
  yield takeLatest(getCancelOTP.type, handleCancelOTP);
  yield takeLatest(getApproveRefund.type, handleApproveRefund);
  yield takeLatest(getDenyRefund.type, handleDenyRefund);
  yield takeLatest(getRefundTrxDetails.type, handleGetRefundTrxDetails);
  yield takeLatest(getAdhocRefund.type, handleAdhocRefund);
  yield takeLatest(getCancelRefund.type, handleGetCancelRefund);
  yield takeLatest(getPaymentRequestByTransUuid.type, handlePaymentReqByTransUuid);
  yield takeLatest(getExportTransDetails.type, handleExportTransDetails);
  yield takeLatest(getChargebackDetails.type, handleGetChargebackDetails);
  yield takeLatest(getChangeChargebackStatus.type, handleChangeChargebackStatus);

}
